module.exports = __webpack_public_path__ + "static/media/Source Info.2a465887.txt";